import { Tag, Typography } from 'antd';
import React from 'react';
import { toggleAnswerCode } from '../../../../ultraPlanUtils';

const { Text } = Typography;

const RoadmapQuestionStep = ({
  question,
  childName,
  codes = [],
  disabled,
  onChange,
}) => (
  <div className="generate-question">
    <div className="generate-question-header">
      <Text strong className="generate-question-title">
        {question?.getTitle(childName)}
      </Text>
      <Text type="secondary" className="ultra-plan-caption">
        {question?.isMultiple ? 'Pick any that apply' : 'Pick one'}
      </Text>
    </div>
    <div className="roadmap-preferences">
      {question?.options?.map(({ code, label }) => (
        <Tag.CheckableTag
          key={code}
          className="roadmap-preference-chip"
          checked={codes?.includes(code)}
          onChange={() =>
            !disabled && onChange(toggleAnswerCode(question, codes, code))
          }
        >
          {label}
        </Tag.CheckableTag>
      ))}
    </div>
  </div>
);

export default RoadmapQuestionStep;
